"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ops_1 = require("./ops");
exports.eye = ops_1.eye;
exports.zeros = ops_1.zeros;
exports.empty = ops_1.empty;
exports.arr = ops_1.arr;
exports.range = ops_1.range;
exports.iszero = ops_1.iszero;
exports.isequal = ops_1.isequal;
exports.torad = ops_1.torad;
exports.todeg = ops_1.todeg;
exports.add = ops_1.add;
exports.mul = ops_1.mul;
exports.sub = ops_1.sub;
exports.div = ops_1.div;
exports.dot = ops_1.dot;
exports.length = ops_1.length;
exports.count = ops_1.count;
var constants_1 = require("./constants");
exports.EPSILON = constants_1.EPSILON;
var ndarray_1 = require("./ndarray");
exports.NDArray = ndarray_1.NDArray;
var complex_1 = require("./complex");
exports.Complex = complex_1.Complex;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bluemath/common/lib/index.js
// module id = 11
// module chunks = 0